export function shouldShowAnnualInstallments({
  shouldUseAnnualInstallments,
  type,
  policyModality,
  selectedInstallmentOption,
  annualInstallmentInfo,
}) {
  if (shouldUseAnnualInstallments) return true;
  if (type !== 'proposal') return false;
  if (policyModality !== 'annual') return false;

  return Boolean(selectedInstallmentOption || annualInstallmentInfo);
}

export function getAnnualInstallmentInfo({ shouldDisplayAnnualInstallments, selectedInstallmentOption, annualInstallmentInfo }) {
  if (!shouldDisplayAnnualInstallments) return null;
  if (!selectedInstallmentOption) return annualInstallmentInfo;

  return {
    annualTotal: selectedInstallmentOption.annualTotalValue,
    installmentValue: selectedInstallmentOption.installmentValue,
    installments: selectedInstallmentOption.installments,
  };
}

export function shouldShowAnnualContractValues({ premiumSummary, capabilities }) {
  return premiumSummary?.isAnnual === true && capabilities?.showAnnualContractValues === true;
}
